// oxlint-disable-next-line no-restricted-imports
import {
  type QueryListAgentPartiesArgs,
  type QueryListConnectionEventsArgs,
  type QueryListConnectorsArgs,
  type QueryListCsvImportsArgs,
  type QueryListCsvImportTransactionFactsArgs,
  type QueryListGlobalPartiesArgs,
  type QueryListInstitutionsArgs,
  type QueryListLedgerBillEmailHistoryArgs,
  type QueryListLedgerBillEmailHistoryGroupsArgs,
  type QueryListLegalEntitiesArgs,
  type QueryListOrganizationsArgs,
  type QueryListPartiesArgs,
  type QueryListPartyExtractionsArgs,
  type QueryListSignupsArgs,
} from "@digits-graphql/admin/graphql-bearer"
import {
  type QueryListActionItemsArgs,
  type QueryListDocumentsArgs,
  type QueryListMetricTransactionsArgs,
  type QueryListTransactionsArgs,
  type QuerySearchEntitiesArgs,
} from "@digits-graphql/frontend/graphql-bearer"
import { offsetLimitPagination } from "src/shared/initializers/typePolicies/helpers"
import { auditFactDetailObjectsPagination, auditFactPagePagination } from "./auditFactPages"
import { auditLogEventReferencesPagination, auditLogPagePagination } from "./auditLog"
import { listActionItemsKeyArgs } from "./listActionItemsKeyArgs"
import { listInsights } from "./listInsights"
import { listTransactionsKeyArgs } from "./listTransactionsKeyArgs"

export const queries = {
  listGlobalPartiesWithSummaries: offsetLimitPagination<QueryListGlobalPartiesArgs>(),
  listInsights,
  listLegalEntities: offsetLimitPagination<QueryListLegalEntitiesArgs>(),
  listParties: offsetLimitPagination<QueryListPartiesArgs>(),
  listSignups: offsetLimitPagination<QueryListSignupsArgs>(),
  listTeams: { merge: false },
  listEmployees: { merge: false },

  searchEntities: offsetLimitPagination<QuerySearchEntitiesArgs>(),

  listTransactions: offsetLimitPagination<QueryListTransactionsArgs>(
    undefined,
    listTransactionsKeyArgs
  ),
  listMetricTransactions: offsetLimitPagination<QueryListMetricTransactionsArgs>(),

  listConnectors: offsetLimitPagination<QueryListConnectorsArgs>(),
  listInstitutions: offsetLimitPagination<QueryListInstitutionsArgs>(),
  listOrganizations: offsetLimitPagination<QueryListOrganizationsArgs>(),
  listApprovalPriorityOrganizations: offsetLimitPagination<QueryListOrganizationsArgs>(),
  listConnectionEvents: offsetLimitPagination<QueryListConnectionEventsArgs>(),
  listLedgerBillEmailHistoryGroups:
    offsetLimitPagination<QueryListLedgerBillEmailHistoryGroupsArgs>(),
  listLedgerBillEmailHistory: offsetLimitPagination<QueryListLedgerBillEmailHistoryArgs>(),

  readAssociatedThreads: { merge: false },

  summarizeInvoiceGroups: { merge: false },

  listAgentParties: offsetLimitPagination<QueryListAgentPartiesArgs>(),
  listPartyExtractions: offsetLimitPagination<QueryListPartyExtractionsArgs>(),

  listCsvImports: offsetLimitPagination<QueryListCsvImportsArgs>(),
  listCsvImportTransactionFacts: offsetLimitPagination<QueryListCsvImportTransactionFactsArgs>(),

  listDocuments: offsetLimitPagination<QueryListDocumentsArgs>(),

  listActionItems: offsetLimitPagination<QueryListActionItemsArgs>(
    undefined,
    listActionItemsKeyArgs
  ),

  listAuditFacts: auditFactPagePagination(),
  listAuditFactsByObject: auditFactPagePagination(),
  readAuditFact: auditFactDetailObjectsPagination(),

  readAuditLog: auditLogPagePagination(),
  readAuditLogEvent: auditLogEventReferencesPagination(),
}
